<template>
  <div>
    <v-dialog v-model="olahDataDialog" persistent max-width="600">
      <v-card>
        <v-card-title class="text-h6 font-weight-bold">
          {{ olahDataTitle }}
        </v-card-title>

        <v-divider class="mx-5"></v-divider>

        <v-card-text class="pb-0 mt-3">
          <v-form ref="form" v-model="valid">
            <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Tipe Box
            </v-card-title>
            <v-select
              v-model="olahData.type_box_id"
              dense
              outlined
              :items="typeBox"
              item-text="name"
              item-value="id"
              :rules="[rules.required]"
            >
            </v-select>

            <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Kode
            </v-card-title>
            <v-text-field
              v-model="olahData.kode"
              outlined
              dense
              :rules="[rules.required]"
              autocomplete="off"
            ></v-text-field>

            <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Deskripsi
            </v-card-title>
            <v-text-field
              v-model="olahData.desc"
              outlined
              dense
              :rules="[rules.required]"
              autocomplete="off"
            ></v-text-field>

            <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Satuan
            </v-card-title>
            <v-text-field
              v-model="olahData.satuan"
              outlined
              dense
              :rules="[rules.required]"
              autocomplete="off"
            ></v-text-field>

             <v-card-title
              class="pa-0 text-subtitle-1 font-weight-bold black--text"
            >
              Material Code
            </v-card-title>
            <v-select
              v-model="olahData.mat_code"
              dense
              outlined
              :items="materialCode"
              item-text="mat_desc"
              item-value="mat_code"
              :rules="[rules.required]"
            >
            </v-select>
          </v-form>
        </v-card-text>

        <v-card-actions class="pt-0 pb-5">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="#61B15A"
            style="text-transform: unset !important"
            @click="closeOlahData"
          >
            Batal
          </v-btn>
          <v-btn
            color="#61B15A"
            class="white--text"
            style="text-transform: unset !important"
            @click="checkType"
            :disabled="!valid"
            :loading="loading"
          >
            {{ olahDataBtn }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: {
    olahDataDialog: Boolean,
    olahDataTitle: String,
    olahDataBtn: String,
    olahData: Object,
    typeAction: String,
    typeBox: Array,
    materialCode: Array,
  },
  data: () => ({
    valid: false,
    loading: false,
    rules: {
      required: (value) => !!value || "Tidak boleh kosong !!",
    },
  }),
  methods: {
    checkType() {
      this.loading = true;
      this.olahData.kode = this.olahData.kode.toUpperCase();
      this.olahData.satuan = this.olahData.satuan.toUpperCase();
      
      if (this.typeAction === "edit") {
        this.edit();
      } else if (this.typeAction === "new") {
        this.new();
      }
    },
    new() {
      const data = JSON.stringify(this.olahData);
      axios
        .post("v1/admin/material", data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(() => {
          this.loading = false;
          this.$emit("reloadData");
          this.closeOlahData();
        })
        .catch((error) => {
          if (error.response) {
            this.loading = false;
            console(error.response);
          }
        });
    },
    edit() {
      const data = JSON.stringify(this.olahData);
      axios
        .put("v1/admin/material", data, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.status === 201) {
            this.loading = false;
            this.$emit("reloadData");
            this.closeOlahData();
          }
        })
        .catch((error) => {
          if (error.response) {
            this.loading = false;
            console(error.response);
          }
        });
    },
    closeOlahData() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.$emit("closeOlahDataDialog");
    },
  },
};
</script>